import { render, staticRenderFns } from "./EpcCard.vue?vue&type=template&id=7b30c8dc&scoped=true"
import script from "./EpcCard.vue?vue&type=script&lang=js"
export * from "./EpcCard.vue?vue&type=script&lang=js"
import style0 from "./EpcCard.vue?vue&type=style&index=0&id=7b30c8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b30c8dc",
  null
  
)

export default component.exports